// This is a hook to set metadata to all the pages.
// Link and name are used for the TopBarBreadCrump component.
// type is used for the 'Ask ImpactAI' button in the PageHeader component.
import usePersonaTerms from './usePersonaTerms';

export const usePageConfig = () => {

    const personaTerms = usePersonaTerms()

    const pageConfigs = {
        // General Pages
        notifications: { link: "notifications", name: "Notificaties", level: 1 },
        helpdesk: { link: "helpdesk", name: "Helpdesk", level: 1 },
        settings: { link: "settings", name: "Instellingen", level: 1 },
        insights: { link: "insights", name: "Inzichten", level: 1 },
        
        // Dashboard Pages
        dashboard: { link: "dashboard", name: "Dashboard", level: 1 },
        dashboards: { link: "dashboards", name: "Dashboards beheren", level: 2, parent: "dashboard" },
        benchmarkdetails: { link: "benchmarkdetails", name: "Benchmark details", parent: "dashboard", level: 2 },
        benchmarkcompanydetail: { link: "benchmarkcompanydetail", name: "Benchmark organisatie", parent: "benchmarkdetails", level: 3, backLabel: "Benchmark details" },
        benchmarkactivity: { link: "benchmark/activity", name: "Benchmark activiteit", parent: "benchmarkdetails", level: 3, backLabel: "Benchmark details" },
        'maatschappelijke-waarde': { link: "maatschappelijke-waarde", name: "Maatschappelijke waarde", parent: "dashboard", level: 2 },
        'impact-per-euro': { link: "impact-per-euro", name: "Impact per euro", parent: "dashboard", level: 2 },
        housevisitsstatus: { link: "housevisitsstatus", name: "Huishoudens per status", parent: "dashboard", level: 2 },

        // Impact Strategy Pages
        impactstrategy: { link: "impactstrategy", name: "Theory of Change", level: 1 },
        organisationcontext: { link: "organisationcontext", name: "Organisatie omschrijving", parent: "impactstrategy", level: 2 },
        stakeholders: { link: "stakeholders", name: "Doelgroepen", parent: "impactstrategy", level: 2 },
        Activities: { link: "Activities", name: "Activiteiten", parent: "impactstrategy", level: 2 },
        addoutputs: { link: "addoutputs", name: "Outputs", parent: "Activities", level: 3 },
        effects: { link: "effects", name: "Effecten", parent: "impactstrategy", level: 2 },
        addindicators: { link: "addindicators", name: "Vragen toevoegen", parent: "effects", level: 3 },
        selectkpis: { link: "selectkpis", name: "Bestaande vragen selecteren", parent: "addindicators", level: 4 },
        theoryofchange: { link: "theoryofchange", name: "Theory of Change", parent: "impactstrategy", level: 2 },

        // Measurement Plan Pages
        measurementplan: { link: "measurementplan", name: "Meten", level: 1 },
        research: { link: "research", name: "Onderzoeken", parent: "measurementplan", level: 2 },
        questionnaires: { link: "questionnaires", name: "Vragenlijsten", parent: "measurementplan", level: 2 },
        sharequestionnaire: { link: "sharequestionnaire", name: "Vragenlijst delen", parent: "research", level: 3 },
        researchresults: { link: "researchresults", name: "Resultaten", parent: "research", level: 3 },
        researchresponses: { link: "researchresponses", name: "Responses", parent: "researchresults", level: 4 },
        // Zonder eigen regel stond hier 'Home / Home' (testronde 2026-10-15, B5).
        researchresultsforms: { link: "researchresultsforms", name: "Ingevulde vragenlijst", parent: "researchresults", level: 4 },
        researchresultssessions: { link: "researchresultssessions", name: "Ingevulde vragenlijst", parent: "researchresults", level: 4 },
        researchresultsopenquestionanalysis: { link: "researchresultsopenquestionanalysis", name: "Open vraag categoriseren", parent: "researchresults", level: 4 },
        importresearchresults: { link: "importresearchresults", name: "Dataset importeren", parent: "research", level: 3 },
        researchbuilder: { link: "researchbuilder", name: "Onderzoek instellingen", parent: "research", level: 3 },
        questionairebuilder: { link: "questionairebuilder", name: "Vragenlijst instellingen", parent: "questionnaires", level: 3 },
        addstandardeffectstoquestionaire: { link: "addstandardeffectstoquestionaire", name: "Gestandaardiseerde effecten toevoegen", parent: "questionairebuilder", level: 4 },
        outputresults: { link: "outputresults", name: "Outputresultaten", parent: "measurementplan", level: 2 },
        events: { link: "events", name: "Activiteiten", parent: "measurementplan", level: 2 },
        eventresults: { link: "eventresults", name: "Activiteit resultaten", parent: "events", level: 3 },
        eventresultsdetail: { link: "eventresultsdetail", name: "Activiteit antwoorden", parent: "events", level: 4 },
        addevent: { link: "addevent", name: "Resultaten toevoegen", parent: "events", level: 3 },
        eventbuilder: { link: "eventbuilder", name: "Formulier aanpassen", parent: "events", level: 3 },
        storytelling: { link: "storytelling", name: "Storytelling", parent: "measurementplan", level: 2 },
        storytellinginterviewdetail: { link: "storytellinginterviewdetail", name: "Interview detail", parent: "storytelling", level: 3 },
        analysis: { link: "analysis", name: "Analyseren", level: 1 },
        addanalysis: { link: "addanalysis", name: "Analyse uitvoeren", parent: "analysis", level: 3 },
        addaianalysis: { link: "addaianalysis", name: "AI analyse uitvoeren", parent: "analysis", level: 3 },
        deepanalysis: { link: "deepanalysis", name: "Diepte-analyse", level: 1 },
        intelligence: { link: "intelligence", name: "Intelligence", level: 1 },
        thema: { link: "intelligence", name: "Thema", parent: "intelligence", level: 2 },
        cel: { link: "intelligence", name: "Cel", parent: "thema", level: 3 },
        inzicht: { link: "intelligence", name: "Inzicht", parent: "intelligence", level: 2 },

        // Personas Pages
        personasexplainer: { link: "personasExplainer", name: "Ondersteuning", level: 1 },
        personas: { link: "personas", name: `Alle ${personaTerms.pluralLower}`, parent: "personasexplainer", level: 2 },
        personabuilder: { link: "personabuilder", name: `${personaTerms.singular} instellingen`, parent: "personas", level: 3 },
        personapresencereportdetail: { link: "personapresencereportdetail", name: "Aanwezigheidsrapport", parent: "personabuilder", level: 4 },
        personagoaldetail: { link: "personagoaldetail", name: "Doel instellingen", parent: "personabuilder", level: 4 },
        personareportdetail: { link: "personareportdetail", name: "Notitie instellingen", parent: "personabuilder", level: 4 },
        researchresultspersonas: { link: "researchresultspersonas", name: "Onderzoeksresultaten", parent: "personabuilder", level: 4 },
        personamethodedetails: { link: "personamethodedetails", name: "Methode instellingen", parent: "personasettings", level: 3 },
        personareportstandarddetails: { link: "personareportstandarddetails", name: "Rapportagestandaard instellingen", parent: "personasettings", level: 3 },
        personagoalprogress: { link: "personagoalprogress", name: "Doel voortgang", parent: "personabuilder", level: 3 },
        researchresultspersonasforms: { link: "researchresultspersonasforms", name: "Onderzoeksresultaten formulier", parent: "researchresultspersonas", level: 4 },
        researchresponsespersonas: { link: "researchresponsespersonas", name: "Onderzoeksresultaten", parent: "researchresultspersonas", level: 4 },

        // Adresses Pages
        housevisitsoverview: { link: "housevisitsoverview", name: "Huishoudens", parent: "personasexplainer", level: 2 },
        adressdetails: { link: "adressdetails", name: "Adres details", parent: "housevisitsoverview", level: 3 },
        adressnotedetail: { link: "adressnotedetail", name: "Notitie instellingen", parent: "adressdetails", level: 4 },
        taskdetail: { link: "taskdetail", name: "Taak instellingen", parent: "adressdetails", level: 4 },
        intakeforms: { link: "intakeforms", name: "Formulieren", parent: "personasexplainer", level: 2 },
        intakeformbuilder: { link: "intakeformbuilder", name: "Formulier aanpassen", parent: "intakeforms", level: 3 },
        materials: { link: "materials", name: "Materialen", parent: "personasexplainer", level: 2 },
        facturatie: { link: "facturatie", name: "Facturatie", parent: "personasexplainer", level: 2 },
        wervingsacties: { link: "wervingsacties", name: "Wervingsacties", parent: "personasexplainer", level: 2 },
        wervingsactie: { link: "wervingsactie", name: "Wervingsactie", parent: "wervingsacties", level: 3 },

        // Portfolio Pages
        portfolio: { link: "portfolio", name: "Portfolio", level: 1 },
        projects: { link: "projects", name: "Projecten", parent: "portfolio", level: 2 },
        portfolioprojectdetails: { link: "portfolioprojectdetails", name: "Project details", parent: "projects", level: 3 },
        synchronisationsportfolio: { link: "synchronisationsportfolio", name: "Koppelingen", parent: "projects", level: 3 },
        projectsOverview: { link: "projectsOverview", name: "Projecten overzicht", parent: "portfolio", level: 2 },

        // Communication Pages
        communication: { link: "communication", name: "Communiceren", level: 1 },
        /* Keys must equal the URL segment (locationParts[2]) — the breadcrumb
           looks pages up by it, and parent references resolve against these
           same keys. The viewer/builder serve both reports and templates from
           the same URL; with ?template=true the breadcrumb looks up the
           "<segment>-template" variant instead. */
        livereports2: { link: "livereports2", name: "Live rapportages", parent: "communication", level: 2 },
        livereporttemplateviewer: { link: "livereporttemplateviewer", name: "Live rapportage", parent: "livereports2", level: 3 },
        livereporttemplatebuilder: { link: "livereporttemplatebuilder", name: "Live rapportage aanpassen", parent: "livereports2", level: 3 },
        "livereporttemplateviewer-template": { link: "livereporttemplateviewer", name: "Live rapportage template", parent: "livereports2", level: 3 },
        "livereporttemplatebuilder-template": { link: "livereporttemplatebuilder", name: "Live rapportage template aanpassen", parent: "livereports2", level: 3 },
        synchronisations: { link: "synchronisations", name: "Synchronisaties", parent: "communication", level: 2 },
        impactinbeeld: { link: "impactinbeeld", name: "Impact in beeld", parent: "communication", level: 2 },

        // Financing Pages
        financing: { link: "financing", name: "Financiering", level: 1 },
        funds: { link: "funds", name: "Fondsen", parent: "financing", level: 2 },

        // Profile and Admin Pages
        profile: { link: "profile", name: "Mijn profiel", level: 1 },
        Data: { link: "data", name: "Data", parent: "Settings", level: 2 },
        UserRoles: { link: "UserRoles", name: "Gebruikersrollen", parent: "Settings", level: 2 },
        Members: { link: "Members", name: "Team", parent: "Settings", level: 2 },
        Settings: { link: "Settings", name: "Instellingen", level: 1 },

        // Onderin het menu. Zonder eigen sleutel valt een pagina terug op
        // 'Home' en staat er 'Home / Home' in de kruimel.
        updates: { link: "updates", name: "Updates", level: 1 },
        updatesmailing: { link: "updatesmailing", name: "Updates mailen", level: 1 },
        // Gesprekken met Decca (beheertenant) — bereikbaar vanaf de kaart op
        // het dashboard, daarom hangt de kruimel aan het dashboard.
        deccagesprekken: { link: "deccagesprekken", name: "Gesprekken met Decca", parent: "dashboard", level: 2 },
        prullenbak: { link: "prullenbak", name: "Prullenbak", level: 1 },

        // Default Page
        default: { link: "Dashboard", name: "Home", level: 1 },
        agenda: { link: "agenda", name: "Agenda", level: 1 },
    };

    // Function to retrieve page details. "-template" variant keys fall back
    // to their base page when no variant entry exists, so pages without a
    // template-specific name keep their normal breadcrumb.
    const getPageConfig = (pageName) => pageConfigs[pageName]
        || pageConfigs[String(pageName).replace(/-template$/, '')]
        || pageConfigs.default;

    // Helper to recursively get breadcrumb data
    const getBreadcrumbTrail = (pageName) => {
        const trail = [];
        let currentPage = getPageConfig(pageName);

        while (currentPage) {
            trail.unshift(currentPage); // Add to the beginning to maintain order
            currentPage = currentPage.parent ? getPageConfig(currentPage.parent) : null;
        }
        
        return trail;
    };

    return { getPageConfig, getBreadcrumbTrail };
};
